import { css } from 'emotion';

import { colors, icons } from '@cobliteam/base-components/src/styles';

export const alertLeftIcon = css`
  color: ${colors.white};
  margin-right: 20px;
  display: flex;
  align-items: center;

  > svg {
    width: ${icons.size.medium};
  }
`;
